/**
 * Reusable PlaceTypeBadge component
 * Displays place type with emoji icon
 * Uses the same icons as the map markers for consistency
 */

import { Badge } from '@/components/ui/badge';
import { PLACE_TYPE_ICONS } from '@/components/passage/map/map-constants';

interface PlaceTypeBadgeProps {
  type: string;
  className?: string;
}

const PLACE_TYPE_LABELS: Record<string, string> = {
  'city': 'City',
  'village': 'Village',
  'region': 'Region',
  'body-of-water': 'Body of Water',
  'mountain': 'Mountain',
  'valley': 'Valley',
  'desert': 'Desert',
  'oasis': 'Oasis',
  'route': 'Route',
  'landmark': 'Landmark',
  'island': 'Island',
  'encampment': 'Encampment'
};

export function PlaceTypeBadge({ type, className = '' }: PlaceTypeBadgeProps) {
  const icon = PLACE_TYPE_ICONS[type];
  const label = PLACE_TYPE_LABELS[type] || type;

  return (
    <Badge 
      variant="secondary" 
      className={`text-xs flex items-center gap-1 ${className}`}
    >
      {icon && <span>{icon}</span>}
      {label}
    </Badge>
  );
}

